// MUI
import { useGridApiRef } from "@mui/x-data-grid-premium";

// Components
import DataSmartTable from "@Layouts/components/Tables/DataSmartTable";
import NoRowsOverlay from "@Layouts/components/Tables/DataSmartTable/additional/NoRowsOverlay";

export default function OemMitsubishiRegionStore(props) {
	const apiRef = useGridApiRef();

	return (
		<DataSmartTable
			apiRef={apiRef}
			columns={props.columns || []}
			rows={props.data || []}
			headerHeight={40}
			rowHeight={25}
			enableCustomScrollbars
			hideFooter
			disableColumnMenu
			disableRowSelectionOnClick
			disableMultipleRowSelection
			checkboxSelection={false}
			columnVisibilityModel={{
				_id: false,
				Rank: false,
				referenceType: false,
			}}
			slots={{
				noRowsOverlay: NoRowsOverlay,
			}}
			slotProps={{
				noRowsOverlay: {
					title: "No Store Metrics data",
				},
			}}
			customProps={{
				tableContainerStyle: { height: "100%", width: "100%" },
				tableClassName: {
					"functional-table first-marked-column": true,
				},
				hide: false,
			}}
		/>
	);
}
